import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, Select, Space } from "antd";
import React, { useContext, useRef, useState } from "react";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import FirebaseApp, { contextApp } from "../../firebase/context";
import { generarId } from "../../utils/generarld";
import { createSet } from "../../firebase/fireStore";
import { useHistory } from "react-router-dom";
const EmotionsDiary = () => {
  let index = 0;
  let history = useHistory();

  const { usuario } = useContext(contextApp);
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");

  const inputRef = useRef(null);
  const addItem = (e) => {
    e.preventDefault();
    setItems([...items, name || `New item ${index++}`]);
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };
  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const UpdateList = async (value) => {
    const { nota, emotion } = value;
    const { data, isError, message } = await createSet(
      "Daily",

      {
        nota,
        emotion,
        email: usuario.email,
        hora: FirebaseApp.firestore.Timestamp.fromDate(new Date()),
      },
      generarId()
    );
    !isError
      ? console.log(data)
      : isError({
          message,
          show: true,
        });
    history.push("/calendario-diario");
  };
  return (
    <div>
      <div>
        {" "}
        {format(new Date(), "PPPpp", {
          locale: es,
        })}
      </div>

      <Form onFinish={UpdateList}>
        <h1>¿Qué emoción sientes hoy?</h1>
        <Form.Item name="emotion">
          <Select
            dropdownRender={(menu) => (
              <>
                {menu}
                <Divider
                  style={{
                    margin: "8px 0",
                  }}
                />
                <Space
                  style={{
                    padding: "0 8px 4px",
                  }}
                >
                  <Input
                    placeholder="Escribe otra emoción"
                    ref={inputRef}
                    value={name}
                    onChange={onNameChange}
                  />
                  <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                    Otra
                  </Button>
                </Space>
              </>
            )}
          >
            <Select.Option value="😱 Miedo">😱 Miedo</Select.Option>
            <Select.Option value="😠 Ira">😠 Ira</Select.Option>
            <Select.Option value="🤮 Asco">🤮 Asco</Select.Option>
            <Select.Option value="😁 Alegría">😁 Alegría</Select.Option>
            <Select.Option value="😭 Tristeza">😭 Tristeza</Select.Option>
            <Select.Option value="😮 Sorpresa">😮 Sorpresa</Select.Option>
            {items.map((item) => (
              <Select.Option key={item}>{item}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="nota">
          <Input.TextArea placeholder="Deja volar tus pensamientos y escríbelos aquí" />
        </Form.Item>
        <Button htmlType="submit">Guardar</Button>
      </Form>
    </div>
  );
};

export default EmotionsDiary;
